import axios from 'axios'

const COUNTRY = 'CO'
const COUNTRY_ID = 5
const COMPANY_ID = 1
const LANGUAGE = 'es-CO'
const FLOW_TYPE = 'CT'
const URL_GLOBAL_PEOPLE_MANAGEMENT = process.env.GLOBAL_PEOPLE_BASE_URI
const URL_PEOPLE_MANAGEMENT = '/businessrelationship/peoplemanagement/v1'
const URL_PEOPLE = `${URL_PEOPLE_MANAGEMENT}/people`
const URL_GLOBAL_PEOPLE = `${URL_GLOBAL_PEOPLE_MANAGEMENT}/people`
const URL_SELLERS_NATURA = '/sgi/pe/v1/api/sellersNatura'
const TENANT_ID = '8c776e6f-d2f7-4f58-b996-16120555ceb1'
const APPLICATION_JSON = 'application/json'
const SOURCE_SYSTEM = 4
const X_API_KEY = process.env.GLOBAL_PEOPLE_X_API_KEY
const CLIENT_ID = process.env.CLIENT_ID

const COL_CLIENT = {
  baseURL: process.env.BASE_URI,
  headers: {
    Accept: APPLICATION_JSON,
    'Content-Type': APPLICATION_JSON,
    client_id: CLIENT_ID,
    country: COUNTRY,
    countryId: COUNTRY_ID,
    language: LANGUAGE,
    sourceSystem: SOURCE_SYSTEM,
    flowType: FLOW_TYPE,
    tenantId: TENANT_ID,
    companyId: COMPANY_ID,
    'x-api-key': X_API_KEY,
  }
}

const URLS = {
  AUTH_PUBLIC: 'api-authorization/api/v2/oauth/access-token',
  SELLER: sellerId => `/sgi/pe/v1/api/sellers/${sellerId}`,
  CSC: () =>
    `${URL_GLOBAL_PEOPLE_MANAGEMENT}/parameters/registrationTeam`,
  ROLES: () =>
    `${URL_GLOBAL_PEOPLE_MANAGEMENT}/people`,
  PEOPLE: personId =>
    personId ? `${URL_GLOBAL_PEOPLE}/${personId}` : URL_GLOBAL_PEOPLE,
  COMPLETE_PEOPLE: personId =>
    personId ? `${URL_GLOBAL_PEOPLE}/${personId}/complete` : URL_GLOBAL_PEOPLE,
  CREATE_PERSON_ROLE: personId =>
    `${URL_GLOBAL_PEOPLE_MANAGEMENT}/people/${personId}/person-roles`,
  APPROVATION: (personId, personRoleId) =>
    `${URL_GLOBAL_PEOPLE_MANAGEMENT}/people/${personId}/person-roles/${personRoleId}/approve`,
  REJECTION: (personId, personRoleId) =>
    `${URL_GLOBAL_PEOPLE_MANAGEMENT}/people/${personId}/person-roles/${personRoleId}/reject`,
  REMOVE_PENDENCY: personRoleId =>
    `${URL_GLOBAL_PEOPLE_MANAGEMENT}/person-roles/${personRoleId}/remove-pendency`,
  REJECTION_REASONS: () => `${URL_GLOBAL_PEOPLE_MANAGEMENT}/rejection-reasons`,
  CONSULTANTS: {
    find: ({ sellerId }) => `${URL_GLOBAL_PEOPLE_MANAGEMENT}/people/${sellerId}`,
    findById: ({ personId, sellerId }) =>
      `${URL_GLOBAL_PEOPLE}/${personId}/consultants?consultantId=${sellerId}`,
    findByName: ({ personId, name, queryString }) =>
      `${URL_GLOBAL_PEOPLE}/${personId}/consultants?name=${name}&${queryString}`,
    findByDocuments: ({ personId, sellerDocument, documentTypeId }) =>
      `${URL_GLOBAL_PEOPLE}/${personId}/consultants?documentNumber=${sellerDocument}&documentTypeId=${documentTypeId}`
  },
  CONTACT_INFORMATION: personId =>
    `${URL_PEOPLE}/${personId}/contactInformation`,
  DOCUMENTS: personId =>
    `${URL_GLOBAL_PEOPLE}/${personId}/documents/attachments`,
  DOCUMENTS_VALIDATION: (personId, documentAttachmentId) =>
    `${URL_GLOBAL_PEOPLE}/${personId}/document-attachments/${documentAttachmentId}/validate`,
  ATTACHMENTS: personId => `${URL_GLOBAL_PEOPLE}/${personId}/attachments`,
  CEASE: (personId, personRoleId) =>
    `${URL_GLOBAL_PEOPLE}/${personId}/person-role/${personRoleId}/cease`,
  SEARCH: query => `${URL_PEOPLE}?${query}`,
  SELLERS_NATURA: salesHierarchyId =>
    `${URL_SELLERS_NATURA}?roleCode=22&roleCode=23&roleCode=24&commercialStructureCode=${salesHierarchyId}&functionCode=1`,
  EMAIL_RESEND: ({ sequence }) =>
    `${URL_GLOBAL_PEOPLE_MANAGEMENT}/emails/${sequence}/send-confirmation-code`,
  EMAIL_VALIDATION: ({ emailId, confirmationCode }) =>
    `${URL_GLOBAL_PEOPLE_MANAGEMENT}/emails/${emailId}/validate/${confirmationCode}`,
  SMS_TOKEN_RESEND: ({ sequence }) =>
    `${URL_GLOBAL_PEOPLE_MANAGEMENT}/telephone/${sequence}/send-confirmation-code`,
  SMS_TOKEN_VALIDATION: ({ sequence, token }) =>
    `${URL_GLOBAL_PEOPLE_MANAGEMENT}/telephones/${sequence}/validate/${token}`,
  FILTERS: `${URL_GLOBAL_PEOPLE_MANAGEMENT}/status-substatus`,
  PAYMENT_PLAN: personId => `${URL_GLOBAL_PEOPLE}/${personId}/payment-plan`,
  ESTABLISHMENTS: `${URL_GLOBAL_PEOPLE_MANAGEMENT}/establishments`,
  SAVE_PERSON_STATUS: (personId, personSubstatus) => `${URL_GLOBAL_PEOPLE}/${personId}/substatus/${personSubstatus}`,
  ALLOCATE_PERSON: (personId) => `${URL_GLOBAL_PEOPLE}/${personId}/allocate-commercial-structure`,
}

export default {
  client: axios.create(COL_CLIENT),
  urls: URLS,
}
